// Shared client-side helpers ported from the original artifact
export const HOURS_PER_DAY = 8;
export const NOTICE_DAYS = 21;

export const LEAVE_TYPES = {
  PTO_VACATION: { label: "PTO — Vacation/Personal", deducts: true, noticeApplies: true },
  PTO_SICK:     { label: "PTO — Sick", deducts: true, noticeApplies: false },
  BEREAVEMENT:  { label: "Bereavement", deducts: false, noticeApplies: false },
  JURY:         { label: "Jury / Court Duty", deducts: false, noticeApplies: false },
  UNPAID_LOA:   { label: "Unpaid Leave of Absence", deducts: false, noticeApplies: true },
};

export function businessDays(start, end) {
  const s = new Date(start + "T00:00:00");
  const e = new Date(end + "T00:00:00");
  if (isNaN(s) || isNaN(e) || e < s) return 0;
  let n = 0;
  const d = new Date(s);
  while (d <= e) {
    const day = d.getDay();
    if (day !== 0 && day !== 6) n++;
    d.setDate(d.getDate() + 1);
  }
  return n;
}

export function noticeDays(start) {
  const s = new Date(start + "T00:00:00");
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((s - today) / 86400000);
}

export function fmt(dstr) {
  if (!dstr) return "";
  const d = new Date(dstr + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

// ---- Federal holidays (computed per year, with weekend observance) ----
function nthWeekday(year, month, weekday, n) {
  const first = new Date(year, month, 1);
  const day = 1 + ((7 + weekday - first.getDay()) % 7) + (n - 1) * 7;
  return new Date(year, month, day);
}
function lastWeekday(year, month, weekday) {
  const last = new Date(year, month + 1, 0);
  const day = last.getDate() - ((7 + last.getDay() - weekday) % 7);
  return new Date(year, month, day);
}
function observed(d) {
  const x = new Date(d);
  if (x.getDay() === 6) x.setDate(x.getDate() - 1);
  else if (x.getDay() === 0) x.setDate(x.getDate() + 1);
  return x;
}
export function federalHolidays(year) {
  const fixed = (m, day, name) => ({ date: observed(new Date(year, m, day)), name });
  return [
    fixed(0, 1, "New Year's Day"),
    { date: nthWeekday(year, 0, 1, 3), name: "Martin Luther King Jr. Day" },
    { date: nthWeekday(year, 1, 1, 3), name: "Presidents Day" },
    { date: lastWeekday(year, 4, 1), name: "Memorial Day" },
    fixed(5, 19, "Juneteenth"),
    fixed(6, 4, "Independence Day"),
    { date: nthWeekday(year, 8, 1, 1), name: "Labor Day" },
    { date: nthWeekday(year, 9, 1, 2), name: "Columbus Day" },
    fixed(10, 11, "Veterans Day"),
    { date: nthWeekday(year, 10, 4, 4), name: "Thanksgiving Day" },
    fixed(11, 25, "Christmas Day"),
  ];
}
export function holidayOn(date) {
  const hs = federalHolidays(date.getFullYear());
  const ds = date.toISOString().slice(0, 10);
  return hs.find((h) => h.date.toISOString().slice(0, 10) === ds) || null;
}
